import type { Player } from '../api/types';
import { ensureString } from './common';
export function adminGetAllUsersRequest() {
  return {
    type: 'ADMIN_USERS_GET_ALL_USERS_REQUEST'
  };
}
export function adminGetAllUsersSuccess(usersArray?: Player[]) {
  const users = Array.isArray(usersArray) ? usersArray : [];
  return {
    type: 'ADMIN_USERS_GET_ALL_USERS_SUCCESS',
    users
  };
}
export function adminGetAllUsersFail() {
  return {
    type: 'ADMIN_USERS_GET_ALL_USERS_FAIL',
    message: {
      messages: ['Nie można pobrać użytkowników'],
      type: 'fail',
    }
  };
}
export function activateFail(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_ACTIVATE_FAIL',
    message: {
      messages: ['Aktywacja nie powiodła się'],
      type: 'fail',
      short
    }
  };
}

export function activateSuccess(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_ACTIVATE_SUCCESS',
    message: {
      messages: ['Aktywacja powiodła się'],
      type: 'success',
      short
    }
  };
}
export function activateUserRequest(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_ACTIVATE_REQUEST',
    short
  };
}

export function deactivateFail(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_DEACTIVATE_FAIL',
    message: {
      messages: ['Deaktywacja nie powiodła się'],
      type: 'fail',
      short
    }
  };
}

export function deactivateSuccess(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_DEACTIVATE_SUCCESS',
    message: {
      messages: ['Deaktywacja powiodła się'],
      type: 'success',
      short
    }
  };
}
export function deactivateUserRequest(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_DEACTIVATE_REQUEST',
    short
  };
}

export function setAdminFail(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_SET_ADMIN_FAIL',
    message: {
      messages: ['Dodawanie uprawnień nie powiodło się'],
      type: 'fail',
      short
    }
  };
}

export function setAdminSuccess(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_SET_ADMIN_SUCCESS',
    message: {
      messages: ['Dodawanie uprawnień powiodło się'],
      type: 'success',
      short
    }
  };
}
export function setUserToAdminRequest(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_SET_ADMIN_REQUEST',
    short
  };
}

export function unsetAdminFail(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_UNSET_ADMIN_FAIL',
    message: {
      messages: ['Usuwanie uprawnień nie powiodło się'],
      type: 'fail',
      short
    }
  };
}

export function unsetAdminSuccess(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_UNSET_ADMIN_SUCCESS',
    message: {
      messages: ['Usuwanie uprawnień powiodło się'],
      type: 'success',
      short
    }
  };
}
export function unsetUserFromAdminRequest(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_UNSET_ADMIN_REQUEST',
    short
  };
}

export function deleteUserFail(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_DELETE_FAIL',
    message: {
      messages: ['Usuwanie użytkownika nie powiodło się'],
      type: 'fail',
      short
    }
  };
}

export function deleteUserSuccess(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_DELETE_SUCCESS',
    message: {
      messages: ['Usuwanie użytkownika powiodło się'],
      type: 'success',
      short
    }
  };
}
export function deleteUserRequest(userShort: string) {
  const short = ensureString(userShort);
  return {
    type: 'ADMIN_USERS_DELETE_REQUEST',
    short
  };
}
export function sendEmail() {
  return {
    type: 'ADMIN_POINTS_SEND_EMAIL'
  };
}
